module.exports = __webpack_public_path__ + "img/lowwaterpressure_attached.cec0a18b.svg";